import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 25 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.375 5a6.377 6.377 0 0 0-1.967 12.439 6.377 6.377 0 0 0 5.717-.907l3.175 3.175a1 1 0 1 0 1.415-1.414l-3.175-3.175a6.367 6.367 0 0 0-.895-8.487 6.366 6.366 0 0 0-4.27-1.63V5Zm0 10.75a4.376 4.376 0 1 1 4.375-4.375 4.377 4.377 0 0 1-4.375 4.375Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }